export const TABLE_DEFAULT_HEIGHT = 900;
